export default {
    "The online prints tool is loading. Please wait": "Siden laster. Vennligst vent.",
    "Add photos": "Velg bilder",
    "Options": "Rediger bilder",
    "Extras": "Tilleggsvalg",
    "Upload your photos": "Velg bilder",
    "Get started! Upload some photos": "Velg bilder",
    "We’re analyzing your photos for the next step. Analyzing photos %s of %s": "Analyserer bilde %s av %s",
    "%s You’ve already uploaded this photo.": "Bildet ‘%s’ er allerede overført.",
    "We couldn’t read the image ‘%s’ so it will not be included in your image collection. This might happen if the file is not an image file (for example a jpeg or png), or because the image is broken. Please check the file and try to re-upload it": "Kunne ikke lese bildet ‘%s’'. Dette kan skyldes at filen ikke er en bildefil, eller at den er ødelagt. Bildet vil ikke legges til i din bestilling",
    "We couldn’t upload the image ‘%s’ because you tried to upload a file type the editor doesn’t support. Supported types are ‘%s’.": "Feil ved opplasting av bildet ‘%s’. Denne filtypen støttes ikke. Gyldige filtyper er %s",
    "We couldn’t upload the image ‘%s’ because the image is too large. The maximum file size is %s.": "Feil ved opplasting av bilde ‘%s’. Bildefilen er for stor. Maks filstørrelse er %s",
    "We couldn’t upload the image ‘%s’ because the image is too large. The maximum allowed dimensions are %s x %s pixels.": "Feil ved opplasting av bilde ‘%s’. Bildefilen er for stor. Maks filstørrelse er %s x %s pixels.",
    "Could not upload ‘%s’ because of error: %s. See console for more info.": "Kunne ikke overføre ‘%s’ grunnet følgende feilmelding: %s.",
    "Upload more photos": "Hent bilder fra datamaskinen",
    "Your photos are uploading: %s of %s complete": "Overfører bilder: %s av %s",
    "Photos added: ‘%s’ to your collection": "Antall bilder lagt til: %s",
    "%s of %s uploaded": "%s av %s overført",
    "Cannot show photo. Please try deleting and uploading again. If it still doesn’t show, please contact us.": "Kan ikke vise bilde. Feil ved lasting.",
    "Your photo collection": "Valgte bilder",
    "Edit your photos": "Rediger bilder",
    "You’re ordering %s photos": "%s bilder totalt",
    "Low resolution images": "Bilder med lav oppløsning",
    "You’ve uploaded one or more images at low resolution. These images might see loss in quality in print.": "Ett eller flere bilder har for lav oppløsning. Dette kan føre til dårligere kvalitet på resultatet.",
    "For better results, choose a smaller print size. Low resolution images have been marked with the icon displayed above.": "For bedre resultat, velg en mindre størrelse på fremkallingen. Bilder med lav oppløsning er markert med ikonet som vises ovenfor.",
    "One or more photos have been cropped to fit the selected print size.": "Ett eller flere bilder er blitt beskjært for å passe til valgt størrelse.",
    "Cropped photos have been marked with the icon displayed above. We recommend that you check your cropped photos before ordering.": "Beskjærte bilder er markert med ikonet som vises ovenfor. Vi anbefaler at du sjekker beskjæringen.",
    "Cannot show photo. Please try deleting and uploading it again. If it still doesn’t show, please contact us.": "Kan ikke vise bildet. Feil ved lasting.",
    "Duplicate photo": "Kopi",
    "Cropped photos": "Beskjærte bilder",
    "Info": "Informasjon",
    "More info": "Mer informasjon",
    "Total": "Totalt",
    "Finish your order": "Tilleggsvalg",
    "Save and finish later": "Lagre og fullfør senere",
    "Got it!": "Ok",
    "Low resolution image": "Lav oppløsning",
    "Photo cropped": "Beskjært bilde",
    "Standard sizes": "Standard størrelse",
    "Enlargements": "Forstørrelser",
    "Tap here to change photo format, add a filter or change quantity, for all photos in this order": "Her kan du endre størrelse og antall, samt legge til filter på alle bilder i bestillingen.",
    "Swipe to reveal more options": "Skyv for å se flere valg",
    "We will make you aware if images are low resolution and notify you when cropping will occur.": "Du vil få beskjed dersom bildene har for lav oppløsning eller må beskjæres",
    "Are you sure you want to delete this product from your shopping basket?": "Slette produkt fra handlekurv?",
    "Edit": "Rediger",
    "Save": "Lagre",
    "Reset": "Tilbakestill",
    "Original": "Original",
    "Sephia": "Sepia",
    "B/W": "B/W",
    "Black and white": "Sort-hvitt",
    "Edit all": "Rediger alle",
    "Done": "Ferdig",
    "Select filter": "Velg filter",
    "Close": "Lukk",
    "Add filter": "Legg til filter",
    "List of available filters...": "Tilgjengelige filtre...",
    "Select format": "Velg format",
    "Choose size": "Velg størrelse",
    "Size:": "Størrelse:",
    "Editing multiple photos will be available when all the photos are analyzed": "Redigering for flere bilder samtidig blir tilgjengelig når programmet har analysert bildene",
    "Amount": "Totalpris",
    "Prints": "Bilder",
    "Cannot show photo. Please try deleting and uploading it again and, if it still doesn’t show, please contact us for assistance.": "Kan ikke vise bilde. Feil ved lasting.",
    "Do more with your photos": "Gjør mer med bildene dine",
    "Order your prints": "Legg i handlekurv",
    "Enlarge": "Forstørr bildene",
    "%s photos": "%s bilder",
    "Paper": "Papir",
    "Other": "Annet",
    "Adding cart items. Two more steps...": "Legger i handlekurv...",
    "We’re processing your order. One more step…": "Behandler bestilling...",
    "Redirecting to cart. Just a moment...": "Videresender til handlekurv...",
    "Something went wrong when adding items to cart. See details below.": "Noe gikk galt, og bildene ble ikke lagt i handlekurven. Se detaljer nedenfor",
    "Image enhancement will automatically optimise your images, bringing out the colour in every photo. We recommend disabling this option if you’ve already enhanced your photos with other software or apps, such as Instagram.": "Bildeoptimalisering vil automatisk optimalisere farger og skarphet i bildene. Dersom du allerede har redigert bildene, eksempelvis med Instagram, er bildeoptimalisering ikke nødvendig.",
    "You're ordering 1 print.": "Du har bestilt %s bilder.",
    "Your device has lost internet connection": "Du er ikke lenger koplet til internett",
    "Delete?": "Fjern?",
    "Yes": "Ja",
    "No": "Nei",
    "The maximum allowed number of photos is %s but you can add multiple orders to one cart and buy all your photos at once. To order more, add this order to your cart then return to the editor.": "Maksgrense for antall bilder er desverre %s. Tips for å unngå denne grensen: det er mulig å legge flere bildeordrer i handlevognen før du bestiller",
    "For you to order, we need to finish uploading your photos": "Alle bilder må lastes opp før man kan gå videre",
    "%s premium prints": "%s standard",
    "Retro": "Retro",
    "We’re sorry: we couldn’t registrer file %s, so we’ve removed it from your order. This might be a temporary error and you could try uploading it again": "Filen %s lot seg ikke registrere/opplastes og er derfor fjernet. Det kan hende dette skyldes en midlertidig feil og at det fungerer hvis du prøver på nytt.",
    "Customer service": "Kundeservice",
    "Privacy": "Personvern",
    "Disclaimer": "Vilkår",
    "Click here to add polaroid text": "Legg til tekst her",
    "Use photos from minnebanken": "Hent bilder fra minnebanken",
    "Please log in with": "Logg på igjen med",
    "Memory bank": "minnebanken",
    "%s photos selected": "%s bilder valgt",
    "Timeline": "Bilder",
    "Events": "Hendelser",
    "Collections": "Album",
    "Import photos": "Bruk bilder",
    "Choose collection": "Velg album",
    "Choose event": "Velg hendelse",
    "Unable to get photos": "Klarte ikke hente bildene",
    "No photos": "Ingen bilder",
    "More photos...": "Flere bilder...",
    "Unable to get timeline data": "Klarte ikke hente tidslinjenavigasjonen",
    "Unable to get events data": "Klarte ikke hente hendelsenavigasjonen",
    "Unable to get collections data": "Klarte ikke hente albumnavigasjonen",
    "No timelines": "Ingen tidslinjer",
    "No events": "Ingen hendelser",
    "No collections": "Ingen album",
    "January": "Januar",
    "February": "Februar",
    "March" : "Mars",
    "April" : "April",
    "May" : "Mai",
    "June": "Juni",
    "July": "Juli",
    "August": "August",
    "September": "September",
    "October": "Oktober",
    "November": "November",
    "December": "Desember",
    "All months": "Alle måneder",
    "All days": "Alle dager",
    "Unable to resize photo. This sometimes happens when the browser is overloaded with lots of large photos. You can try a different browser, order fewer photos at a time or first upload to Photo Organiser.": "Klarte ikke forminske bildet. Dette kan skje hvis nettleseren er overarbeidet pga mange store bilder. Alternativt kan du forsøke med mindre antall bilder, en annen nettleser eller å først laste opp bildene til minnebanken",
    "Unable to resize photo. This sometimes happens when the browser is overloaded with lots of large photos. You can try a different browser or order fewer photos at a time.": "Klarte ikke forminske bildet. Dette kan skje hvis nettleseren er overarbeidet pga mange store bilder. Alternativt kan du forsøke med mindre antall bilder eller bruke en annen nettleser.",
    "Could not load photos from Photo Organiser because there are no photos in the basket.": "Ingen bilder ble lastet inn fra minnebanken fordi handlekurven i minnebanken er tom",
    "Please know that if you leave the page now, your changes will be lost": "Hvis du forlater siden vil du miste arbeidet ditt",
    "Quantity:": "Antall:",
    "Loading photos from minnebanken...": "Laster inn bilder fra minnebanken...",
    "Select all": "Velg alle",
    "Select nothing": "Velg bort alle",
    "Check your photos": "Sjekk bildene dine",
    "Loading...": "Laster...",
    "Loading, please wait": "Bare vent litt! Vi kommer hvert øyeblikk.",
    "%s images have a low-resolution warning. Please double-check the photos marked with a warning sign. If you don't, we can't guarantee top quality on your prints.": "%s bilder har lav oppløsning. Vennligst dobbeltsjekk bildene merket med varseltegn. Ellers kan vi ikke garantere topp kvalitet på dine bildefremkallinger.",
    "%s photos have been cropped and not validated. Please double-check the photos marked with a warning sign. If you don't, we can't guarantee top quality on your prints.": "%s bilder har blitt beskåret automatisk og er ikke tilpasset av deg. Vennligst dobbeltsjekk bildene merket med varseltegn. Ellers kan vi ikke garantere at utsnittet blir slik du ønsker.",
    "Some photos need attention": "Noen av bildene trenger oppmerksomhet",
    "Continue": "Fortsett",
    "Check photos": "Kontroller bildene dine",
    "Check your cropped photos": "Sjekk dine beskårede bilder",
    "Check your low resolution images": "Sjekk bilder med lav oppløsning",
    "Unable to load images from temporary selection API in Photo Organise": "Klarte ikke laste inn bilder fra TemporarySelectionApi",
    "Unfortunately your browser does not support all options for creating this product. Please install Safari, Chrome, Firefox or a newer version of Internet Explorer (11 or Edge) and start again.": "Dessverre støtter ikke denne nettleseren alle funksjonene for dette produktet. Vennligst installer Safari, Chrome, Firefox eller den nyeste versjonen av Internet Explorer (10 eller høyere) og forsøk igjen."
};
